import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  CircularProgress,
  Container,
  Typography,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Button,
  Card,
  CardContent,
} from "@material-ui/core";
import { DateTimePicker } from "@material-ui/pickers";
import { Registration } from "../../../../common";
import withAuth from "../auth/withAuth";
import AuthHelperMethods from "../../util/AuthHelperMethods";
import { getRegistrationsWithinRange } from "../../services/registrationService";
import RegistrationScreen from "./Registration";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RegistrationCard from "../RegistrationCard";

const RegistrationsInCards = function Registrations() {
  const Auth: any = new AuthHelperMethods();

  const [registrations, setRegistrations]: [any, any] = useState(null);
  const [activeRegistration, setActiveRegistration]: [
    Registration | null,
    any
  ] = useState(null);
  const [filterFrom, setFilterFrom] = useState(
    moment().startOf("month").toDate()
  );
  const [filterTo, setFilterTo] = useState(moment().endOf("month").toDate());

  useEffect(() => {
    setRegs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterFrom, filterTo]);

  const setRegs = async () => {
    setRegistrations(null);
    const data = await getRegistrationsWithinRange(
      Auth.getConfirm()._id,
      filterFrom,
      filterTo
    );
    setRegistrations(data);
  };

  const onChangeFilterFrom = (value: any) => {
    setFilterFrom(value);
  };

  const onChangeFilterTo = (value: any) => {
    setFilterTo(value);
  };

  const calcTotalAmount = (registrations: Registration[]): number => {
    let total = 0;
    registrations.forEach(
      (row) => (total = total + parseFloat(row.totalAmount))
    );
    return total;
  };

  const back = () => {
    setRegistrations(null);
    setRegs();
    setActiveRegistration(null);
  };

  if (registrations) {
    if (activeRegistration) {
      return (
        <RegistrationScreen registration={activeRegistration} back={back} />
      );
    } else {
      if (registrations.length > 0) {
        return (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Container component="main" maxWidth="lg">
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <Typography component="h1" variant="h4">
                  Registraties
                </Typography>
              </div>
              <ExpansionPanel style={{ marginBottom: "15px" }}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Filter</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className="filterContainer">
                    <div className="filter">
                      <div className="filterField">
                        <DateTimePicker
                          ampm={false}
                          label="Van"
                          inputVariant="outlined"
                          value={filterFrom}
                          onChange={onChangeFilterFrom}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="filterField">
                        <DateTimePicker
                          ampm={false}
                          label="Tot"
                          inputVariant="outlined"
                          value={filterTo}
                          onChange={onChangeFilterTo}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                    <div className="filter">
                      <div className="filterField">
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          fullWidth={true}
                          onClick={() => {
                            setFilterFrom(
                              moment()
                                .subtract(1, "months")
                                .startOf("month")
                                .toDate()
                            );
                            setFilterTo(
                              moment()
                                .subtract(1, "months")
                                .endOf("month")
                                .toDate()
                            );
                          }}
                        >
                          Vorige Maand
                        </Button>
                      </div>
                      <div className="filterField">
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          fullWidth={true}
                          onClick={() => {
                            setFilterFrom(moment().startOf("month").toDate());
                            setFilterTo(moment().endOf("month").toDate());
                          }}
                        >
                          Deze maand
                        </Button>
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <Card className="gridCard">
                <CardContent style={{ textAlign: "center", width: "100%" }}>
                  Totale vergoeding:
                  <h1>€ {calcTotalAmount(registrations).toFixed(2)}</h1>
                </CardContent>
              </Card>
              {(registrations as Registration[]).map((registration) => (
                <RegistrationCard
                  onClick={() => setActiveRegistration(registration)}
                  key={registration._id}
                  registration={registration}
                />
              ))}
            </Container>
          </MuiPickersUtilsProvider>
        );
      } else {
        return (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Container component="main" maxWidth="lg">
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <Typography component="h1" variant="h4">
                  Registraties
                </Typography>
              </div>
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Filter</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className="filterContainer">
                    <div className="filter">
                      <div className="filterField">
                        <DateTimePicker
                          ampm={false}
                          label="Van"
                          inputVariant="outlined"
                          value={filterFrom}
                          onChange={onChangeFilterFrom}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="filterField">
                        <DateTimePicker
                          ampm={false}
                          label="Tot"
                          inputVariant="outlined"
                          value={filterTo}
                          onChange={onChangeFilterTo}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                    <div className="filter">
                      <div className="filterField">
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          fullWidth={true}
                          onClick={() => {
                            setFilterFrom(
                              moment()
                                .subtract(1, "months")
                                .startOf("month")
                                .toDate()
                            );
                            setFilterTo(
                              moment()
                                .subtract(1, "months")
                                .endOf("month")
                                .toDate()
                            );
                          }}
                        >
                          Vorige Maand
                        </Button>
                      </div>
                      <div className="filterField">
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          fullWidth={true}
                          onClick={() => {
                            setFilterFrom(moment().startOf("month").toDate());
                            setFilterTo(moment().endOf("month").toDate());
                          }}
                        >
                          Deze maand
                        </Button>
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Typography component="h1" variant="h6">
                  Je hebt geen registraties in deze periode!
                </Typography>
              </div>
            </Container>
          </MuiPickersUtilsProvider>
        );
      }
    }
  } else {
    return (
      <div style={{ textAlign: "center", marginTop: "20%" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
};

export default withAuth(RegistrationsInCards);
